import LocationPickerState from '../store/schema/LocationPickerState';
import RequestStatus from '../store/schema/RequestStatus';

export default function getDefaultPickerState(): LocationPickerState {
    return {
        findLocationRequestStatus: RequestStatus.NotInitiated,
        queryString: '',
        smtpAddressOfAccount: null,
        suggestionSet: [],
        displayedSuggestionsTimestamp: null,
        requestedSuggestionsSearchMode: null,
        requestedSuggestionsRequiredAttendees: null,
        requestedSuggestionsOptionalAttendees: null,
        requestedSuggestionsTimeSlot: null,
        requestedSuggestionsRecurrence: null,
        pendingPromise: null,
    };
}
